import React from 'react'
import { Grid, Typography, Button, MenuItem } from "@material-ui/core";
import { ValidatorForm, SelectValidator } from 'react-material-ui-form-validator';
import { useForm } from '../../../../hooks/useForm';
import CancelIcon from "@material-ui/icons/Cancel";
import SaveIcon from "@material-ui/icons/Save";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { SelectorCuentas } from './SelectorCuentas';
import { getCategorias } from '../../../../actions/contrataciones/contratacionesCartilla';

export const FormCuentaContable = ({formData, editable, handleSubmit, handleCancel, idNomenclador}) => {
    const dispatch = useDispatch();
    const { categorias } = useSelector(state => state.contratacionesCartilla);
    const [primerCateg, setPrimerCateg] = useState([]);
    const [segundaCateg, setSegundaCateg] = useState([]);
    const [tercerCateg, setTercerCateg] = useState([]);

    const setCateg = {
        primerCod: (items) => setPrimerCateg(items.filter( categ => !categ.cod2)),
        segundoCod: (value, items) => setSegundaCateg(items.filter( 
            categ => (!categ.cod3 && categ.cod2) && 
            (categ.cod1 === parseInt(value))
        )),
        tercerCod: (value, items) => setTercerCateg(items.filter( 
            categ =>   (categ.cod3) && 
            (categ.cod2 === parseInt(value)) 
        )),
        defaultCod: cod => cod === 2 ? formValues.cod2 = null : formValues.cod3 = null 
    }

    const datosNuevaCuenta = {
        idNomenclador: idNomenclador,
        cod1: '',
        cod2: '',
        cod3: '',
        idPlanCuenta: '',
        idPlanCuentaCP: '',
    }

    const [
        formValues,
        handleInputChange,
        ,
        ,
        setearValor2
    ] = useForm(formData?.idcuentasNomenclador ? formData : datosNuevaCuenta);

    const handleChangeCascade = (e, cod) => {
        if(cod === 1){
            setSegundaCateg([]);
            setTercerCateg([]);  
            setCateg.segundoCod(e.target.value, categorias);
            
            setCateg.defaultCod(2)
            setCateg.defaultCod(3)
        }
        if(cod === 2){
            setTercerCateg([]);
            setCateg.tercerCod(e.target.value, categorias);

            setCateg.defaultCod(3)
        }
        handleInputChange(e);
    }

    const onSubmit = (e) => {
        e.preventDefault()
        if (editable)
            handleSubmit({ ...formValues })
    }

    useEffect(() => {
        setCateg.primerCod(categorias);
        setCateg.segundoCod(formValues.cod1, categorias);
        setCateg.tercerCod(formValues.cod2, categorias);
    }, [setPrimerCateg, setSegundaCateg, setTercerCateg, categorias])

    useEffect(() => {
        if(categorias.length === 0) 
            dispatch(getCategorias())
    }, [dispatch, categorias]);

    return (
        <ValidatorForm onSubmit={onSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={12} style={{marginBottom: '2em'}}>
                    <Grid container spacing={1}>
                        <Typography variant="button">Categorias</Typography>
                        <Grid item xs={12}>
                            <SelectValidator
                                variant="standard"
                                fullWidth
                                margin="normal"
                                name="cod1"
                                value={formValues.cod1}
                                onChange={e => handleChangeCascade(e, 1)}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            >
                                {primerCateg.map((item) => (
                                    <MenuItem value={item.cod1}>{`${item.descripcion}`}</MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                        <Grid item xs={12}>
                            <SelectValidator
                                variant="standard"
                                fullWidth
                                margin="normal"
                                name="cod2"
                                value={formValues.cod2}
                                disabled={segundaCateg.length === 0}
                                onChange={e => handleChangeCascade(e, 2)}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            >
                                {segundaCateg.map((item) => (
                                    <MenuItem value={item.cod2}>{`${item.descripcion}`}</MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                        <Grid item xs={12}>
                            <SelectValidator
                                variant="standard"
                                fullWidth
                                margin="normal"
                                name="cod3"
                                value={formValues.cod3}
                                disabled={tercerCateg.length === 0}
                                onChange={e => handleChangeCascade(e, 3)}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            >
                                {tercerCateg.map((item) => (
                                    <MenuItem value={item.cod3}>{`${item.descripcion}`}</MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Typography variant="button">Plan de cuentas</Typography>
                        <Grid item xs={12}>
                            <SelectorCuentas 
                                valuesCuenta={formValues}
                                setearIdCuenta={setearValor2}
                                idCuenta
                                label='Cuenta'
                                validators
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SelectorCuentas 
                                valuesCuenta={formValues}
                                setearIdCuenta={setearValor2}
                                label='Cuenta CP'
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} justify="flex-end" style={{ marginTop: '1em' }}>
                <Grid item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<CancelIcon />}
                        onClick={handleCancel}
                    >
                        CANCELAR
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<SaveIcon />}
                    type='submit'
                    >
                    GUARDAR
                    </Button>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
